const MODULE_NAME = 'fulcrum/container/Report/Greenlight'

const MOUNT = 'fulcrum/container/Report/MOUNT'
const ON_INPUT_CHANGE = 'fulcrum/container/Report/Greenlight/INPUT_CHANGE'
const ON_ENTER = 'fulcrum/container/Report/Greenlight/ON_ENTER'
const ON_SKU_CHANGE = 'fulcrum/container/Report/Greenlight/ON_SKU_CHANGE'
const CLEAR_SKU = 'fulcrum/container/Report/Greenlight/CLEAR_SKU'
const CLEAR_SEARCH = 'fulcrum/container/Report/Greenlight/CLEAR_SEARCH'
const CLEAR_TABLE_FILTER = 'fulcrum/container/Report/Greenlight/CLEAR_TABLE_FILTER'
const CLEAR_TABLE_SORT = 'fulcrum/container/Report/Greenlight/CLEAR_TABLE_SORT'
const UPDATE_SKU = 'fulcrum/container/Report/Greenlight/UPDATE_SKU'
const UPDATE_SEARCH = 'fulcrum/container/Report/Greenlight/UPDATE_SEARCH'
const UPDATE_TABLE_FILTER = 'fulcrum/container/Report/Greenlight/UPDATE_TABLE_FILTER'
const UPDATE_TABLE_SORT = 'fulcrum/container/Report/Greenlight/UPDATE_TABLE_SORT'

const FETCH_PRODUCT_SKUS = 'fulcrum/container/Report/Greenlight/FETCH_PRODUCT_SKUS'
const FETCH_PRODUCT_SKUS_START = 'fulcrum/container/Report/Greenlight/FETCH_PRODUCT_SKUS_START'
const FETCH_PRODUCT_SKUS_SUCCESS = 'fulcrum/container/Report/Greenlight/FETCH_PRODUCT_SKUS_SUCCESS'
const FETCH_PRODUCT_SKUS_ERROR = 'fulcrum/container/Report/Greenlight/FETCH_PRODUCT_SKUS_ERROR'

const FETCH_GREENLIGHT_REPORT = 'fulcrum/container/Report/Greenlight/FETCH_GREENLIGHT_REPORT'
const FETCH_GREENLIGHT_REPORT_START = 'fulcrum/container/Report/Greenlight/FETCH_GREENLIGHT_REPORT_START'
const FETCH_GREENLIGHT_REPORT_SUCCESS = 'fulcrum/container/Report/Greenlight/FETCH_GREENLIGHT_REPORT_SUCCESS'
const FETCH_GREENLIGHT_REPORT_ERROR = 'fulcrum/container/Report/Greenlight/FETCH_GREENLIGHT_REPORT_ERROR'

const REPORT_FIELDS = [
  'project',
  'revision',
  'partnerSite',
  'partner',
  'boostClock',
  'vfOffset',
  'minTgp',
  'acousticIdle',
  'gpuTempIdle',
  'acousticSingle',
  'gpuTempSingle',
  'acousticSli',
  'gpuTempSli',
  'status',
  'totalCardDimensionX',
  'totalCardDimensionY',
  'totalCardDimensionZ'
]

export {
  MODULE_NAME,
  MOUNT,
  ON_INPUT_CHANGE,
  ON_ENTER,
  ON_SKU_CHANGE,
  CLEAR_SKU,
  CLEAR_SEARCH,
  CLEAR_TABLE_FILTER,
  CLEAR_TABLE_SORT,
  UPDATE_SKU,
  UPDATE_SEARCH,
  UPDATE_TABLE_FILTER,
  UPDATE_TABLE_SORT,
  FETCH_PRODUCT_SKUS,
  FETCH_PRODUCT_SKUS_START,
  FETCH_PRODUCT_SKUS_SUCCESS,
  FETCH_PRODUCT_SKUS_ERROR,
  FETCH_GREENLIGHT_REPORT,
  FETCH_GREENLIGHT_REPORT_START,
  FETCH_GREENLIGHT_REPORT_SUCCESS,
  FETCH_GREENLIGHT_REPORT_ERROR,
  REPORT_FIELDS,
}
